import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-background px-5 py-12 sm:py-20" data-id="element-93" data-mp="1hbgu4bwv3v38">
      <div className="mx-auto max-w-2xl" data-id="element-94" data-mp="1cft27oqzwnu1">
        <h2 className="text-center font-display text-2xl font-bold text-foreground sm:text-4xl" data-id="element-95" data-mp="1ccnh0klhm63l">
          Najczęstsze pytania
        </h2>

        <div className="mt-8 divide-y divide-primary/15 border-y border-primary/15" data-id="element-96" data-mp="25472yc9gxy9a">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.question} data-id="element-97" data-mp="1v5hl2jhkodt1" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex min-h-[48px] w-full items-center justify-between gap-4 py-4 text-left" data-id="element-98" data-mp="1v4g4y0lp914g">
                  <span className="text-sm font-bold text-foreground sm:text-base" data-id="element-99" data-mp="1kors7i2c5wi1">{faq.question}</span>
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-secondary text-primary-strong" data-id="element-100" data-mp="1plibee9ft87o">
                    {isOpen ? <MinusIcon className="h-4 w-4" aria-hidden="true" data-id="element-101" data-mp="1fo44p6dbfxsk" /> : <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-102" data-mp="11wp8fxuee03k" />}
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-103" data-mp="16pidkmts3ag6">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-104" data-mp="s0duz4j2n47j">
                      <p className="pb-4 text-sm leading-relaxed text-foreground/75" data-id="element-105" data-mp="2pmn3nt8u7pyk">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}